import { render, staticRenderFns } from "./ChooseNationalId.vue?vue&type=template&id=37f99cc3&scoped=true&"
import script from "./ChooseNationalId.vue?vue&type=script&lang=ts&"
export * from "./ChooseNationalId.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseNationalId.vue?vue&type=style&index=0&id=37f99cc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f99cc3",
  null
  
)

export default component.exports